
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import MaskedPhoneInput from "@/components/common/MaskedPhoneNew.vue";
import ExperienceForm from "@/components/profile/experiences/ExperienceFormResume.vue";
import FormWrapper from "@/components/form/FormWrapper.vue";
import FormGroup from "@/components/form/FormGroupCustom.vue";
import UIButton from "@/components/button/ui-button.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import DeleteGray from "@/components/icons/DeleteGray.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";

@Component({
  components: {
    ModalContent,
    ModalFullScreen,
    CrossIconHover,
    FormWrapper,
    MaskedPhoneInput,
    ExperienceForm,
    FormGroup,
    UIButton,
    CrossIcon,
    DeleteGray,
    LoadingOverlay,
  },
})
export default class ManagementAddContractorInfo extends Vue {
  @Prop({ type: Object, required: false })
  readonly experiences?: Object;

  isHovered: boolean = false;
  updatedExperience: Object = this.experiences;

  closeModal(): void {
    this.$emit("close");
  }

  addExperience(newExp) {
    if (this.updatedExperience) {
      this.$emit("edit-experience", {
        oldName: this.updatedExperience,
        newName: newExp,
      });
    } else {
      this.$emit("add-experience", newExp);
    }
    this.$emit("close");
  }

  editExperience(newExp) {
    this.$emit("edit-experience", {
      oldName: this.updatedExperience,
      newName: newExp,
    });
    this.closeModal();
  }
}
